import { cn } from "@wa/ui";
import { fmtNum } from "../../../ui";

/**
 * One number of an engine, in the sunk tile the settings panel opens with.
 *
 * `hot` paints a non-zero value in the destructive colour: new leads waiting,
 * homepages failing right now, follow-ups already late. Zero stays plain,
 * because a red zero is an alarm about nothing.
 *
 * The scan autopilot, the brain autopilot and the lead watch each drew a
 * private copy of this tile when they were cards; now all three hand their
 * numbers to the same one.
 */
export function EngineStat({ label, value, hot }: { label: string; value: number; hot?: boolean }) {
  return (
    <div className="crm-pstat">
      <b className={cn(hot && value > 0 && "text-[var(--color-destructive)]")}>{fmtNum(value)}</b>
      <span>{label}</span>
    </div>
  );
}
